import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-services-area',
  templateUrl: './services-area.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './services-area.component.scss'
})
export class ServicesAreaComponent {
  @Input() subtitle : string = "";
  @Input() title : string = "";
  @Input() detail : string = "";
  @Input() class : string = "";

  @Input() box1title : string = "";
  @Input() box1Detail : string = "";

  @Input() box2title : string = "";
  @Input() box2Detail : string = "";

  @Input() box3title : string = "";
  @Input() box3Detail : string = "";

  @Input() box4title : string = "";
  @Input() box4Detail : string = "";

  @Input() box5title : string = "";
  @Input() box5Detail : string = "";

  @Input() box6title : string = "";
  @Input() box6Detail : string = "";
}
